var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFamily(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 46,
    fill: "#E2EAF5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#55739D",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 49,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79,
    cy: 49,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 61,
    r: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5 84v-7.3c0-9 5.6-15.7 12.5-15.7s12.5 6.7 12.5 15.7V84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5 84v-7.3c0-9 5.6-15.7 12.5-15.7s12.5 6.7 12.5 15.7V84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5 85v-5.8c0-7.4 4.7-12.7 10.5-12.7s10.5 5.3 10.5 12.7V85"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamily);
export default __webpack_public_path__ + "static/media/family.d97142ee4f07ad5c65d6e5fc9a182022.svg";
export { ForwardRef as ReactComponent };